import {get} from 'react-hook-form'

import {FieldNames, isFieldDirty, normalizeFieldName} from '../../fields'
import {useOrderProcessFormContext} from '../useOrderProcessFormContext'

export const useIsFieldDirty = (fieldName: FieldNames) => {
  const {watch, formState} = useOrderProcessFormContext()
  const defaultValue = get(formState.defaultValues, normalizeFieldName(fieldName).field)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fieldValue = watch(normalizeFieldName(fieldName).field) as any

  return isFieldDirty(fieldName, fieldValue, defaultValue)
}
